// extracted by mini-css-extract-plugin
export var active = "_1j-9";
export var backButton = "_1j-8";
export var clone = "_1j-e";
export var collapseBar = "_1j-k";
export var collapseMode = "_1j-m";
export var collapsed = "_1j-o";
export var dimmed = "_1j-i";
export var dragHandle = "_1j-c";
export var dropdownIcon = "_1j-g";
export var expanding = "_1j-n";
export var hidden = "_1j-x";
export var iconContainer = "_1j-q";
export var iconSwapper = "_1j-w";
export var navItem = "_1j-6";
export var navItemIcon = "_1j-f";
export var navProfile = "_1j-7";
export var notificationCountBadge = "_1j-j";
export var notificationDot = "_1j-r";
export var optionsContainer = "_1j-h";
export var primaryNav = "_1j-0";
export var primaryNavDivider = "_1j-v";
export var primaryNavResizeHandle = "_1j-2";
export var primaryNavResizing = "_1j-1";
export var primaryNavTabSection = "_1j-u";
export var primaryTab = "_1j-p";
export var primaryTabIconBox = "_1j-s";
export var secondaryNav = "_1j-3";
export var selected = "_1j-t";
export var settingsNav = "_1j-4";
export var settingsNavItems = "_1j-5";
export var show = "_1j-d";
export var sideNav = "_1j-l";
export var teamItem = "_1j-a";
export var userProfileItem = "_1j-b";